import { getObservableT } from "../Infra/i18next";
import { FormModel } from "./FormModel";
import { validators } from "../Logic/Validators";
const t = getObservableT("patients");
export class AccountSetupCompletionManager {
    constructor() {
        this.ageValidationErrorText = t("You must be at least 18 years old to use HealthEx");
        this.formModel = new FormModel({
            firstName: "",
            lastName: "",
            birthday: "",
            mobilePhone: "",
        }, []);
    }
    prepopulate(patientInfo) {
        if (!patientInfo)
            return;
        if (patientInfo.firstName) {
            this.formModel.updateInput({ firstName: patientInfo.firstName }, false);
        }
        if (patientInfo.lastName) {
            this.formModel.updateInput({ lastName: patientInfo.lastName }, false);
        }
        if (patientInfo.dateOfBirth) {
            this.formModel.updateInput({ birthday: patientInfo.dateOfBirth }, false);
        }
        if (patientInfo.phone) {
            this.formModel.updateInput({ mobilePhone: patientInfo.phone }, false);
        }
    }
    validateInput() {
        const { notBlank, validPhone, pastDate, atLeast18YearsOld } = validators;
        const f = this.formModel;
        f.clearErrors();
        f.validateField("firstName", notBlank, t("Enter your first name"));
        f.validateField("lastName", notBlank, t("Enter your last name"));
        f.validateField("birthday", notBlank, t("Enter your birthday"));
        f.validateField("birthday", pastDate, t("Enter a valid birthday"));
        f.validateField("birthday", atLeast18YearsOld, this.ageValidationErrorText);
        f.validateField("mobilePhone", notBlank, t("Enter your phone number"));
        f.validateField("mobilePhone", validPhone, t("Enter a valid phone number"));
        return !f.hasErrors();
    }
    get hasAgeValidationError() {
        return this.formModel.errors.birthday === this.ageValidationErrorText;
    }
    get input() {
        return this.formModel.input;
    }
}
